module.exports = __webpack_public_path__ + "img/foot-bac-icon.6cedf0dc.gif";